export default __webpack_public_path__ + "static/media/gallery_09.563e7212.jpg";